import { NurseLayout } from "@/components/layout/nurse-layout";
import { CpdModuleReaderContent } from "@/components/cpd/cpd-module-reader";

export default function NurseLearnModule() {
  return (
    <NurseLayout title="Learning Hub">
      <CpdModuleReaderContent listPath="/nurse/learn" />
    </NurseLayout>
  );
}
